var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.284947 18.2151C0.665349 18.595 1.2816 18.595 1.66201 18.2151L9.01172 10.8653L16.3614 18.2151C16.7453 18.5728 17.3436 18.5622 17.7146 18.1912C18.0857 17.8201 18.0962 17.2219 17.7385 16.838L10.3888 9.48828L17.7385 2.13856C18.0962 1.75466 18.0857 1.15642 17.7146 0.785376C17.3436 0.414335 16.7453 0.403779 16.3614 0.761501L9.01172 8.11122L1.66201 0.761501C1.27811 0.403779 0.679869 0.414335 0.308827 0.785376C-0.0622143 1.15642 -0.0727753 1.75466 0.284947 2.13856L7.63466 9.48828L0.284947 16.838C-0.0949823 17.2184 -0.0949823 17.8347 0.284947 18.2151Z",
    fill: "#0F0F0F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.c3b28f16.svg";
export { ForwardRef as ReactComponent };